<template>
  <div class="people">
      <div class="people-header">
          <el-form :inline="true" >
              <el-form-item label-width="80px" label="姓名">
                  <el-input v-model="formList.n" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label-width="80px" label="机构">
                  <el-input v-model="formList.o" placeholder="请输入机构名称"></el-input>
              </el-form-item>
              <el-form-item>
                    <el-button type="primary" @click="getTabel2">查询</el-button>
                    <el-button type="success" @click="rest">重置</el-button>
              </el-form-item>
          </el-form>
      </div>
      <div class="res-list clearfix" v-loading="loading" >
        <div
            class="exp-box"
            :style="{width:'25%'}"
            v-for="( item, index ) in fieldData.obj"
            :key="index"
        >
        <div class="exp-box-box">
            <div class="exp-int clearfix"  @click="goDetail(item)">
                <el-image
                v-if="item.avatar || item.avatarUrl"
                class="exp-header"
                :src="item.avatar?item.avatar:(item.avatarUrl.indexOf('http')>-1?item.avatarUrl:'/old/public'+item.avatarUrl)"
                fit="contain"
                
                >
                <div slot="placeholder" class="image-slot"    >
                    <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
                </div>
                <div slot="error" class="image-slot"    >
                    <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
                </div>
                </el-image>
                <el-image
                
                v-else
                class="exp-header"
                src="http://expert.ckcest.cn/autoload/images/avatar.png"
                fit="contain"
                ></el-image>
                <div class="exp-textint">
                <h5 >{{item.name}} {{item.honor}}</h5>
                <p>{{item.organization}}</p>
                <p>{{/^[0-9]+$/.test(item.kId) ? '已认领' : '未认领'}}</p>
                </div>
            </div>
            <p
                class="isni"
                v-if="item.isni"
            >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3) }}</p>
            <p class="isni" v-else></p>
            <p
                class="subject"
                :title="item.subject"
                v-if="item.subject && item.subject !== ''"
            >学科：{{item.subject}}</p>
            <p class="subject" :title="item.subject" v-else></p>
            <ul
                class="keywords clearfix"
                v-if="item.keyword"
                style="background-color: #f5f5f5;"
            >
                <li v-for="li in item.keywordList" :key="li">{{li}}</li>
            </ul>
            <ul class="keywords clearfix" v-else></ul>
            </div>
            
        </div>
        <div class="exp-box" v-if="fieldData.data.length" :style="{width:'25%'}">
            <div class="exp-box-box create-btn" @click="showEditDilog('clear')">
                <p>以上均不是点击创建</p>
            </div>
        </div>
        <div style="display:flex;height: 100%; text-align:center;width:100%">
            <span style="margin:auto;font-size: 20px;" v-if="!fieldData.data.length">暂无关联领域</span>
        </div>
    </div>
    <pagination
        :pageSizes="pageData.pageSizes"
        :total="fieldData.total"
        :page.sync="pagetion.from"
        :limit.sync="pagetion.size"
        :layout="pageData.layout"
        @pagination="getPage"
    />
    <el-dialog
        v-loading="loading6"
        title="提 示"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <span>{{ msg }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="showEditDilog()">确 定</el-button>
        </span>
      </el-dialog>
       <el-dialog title="创建学者" :visible.sync="showEdit" width="400px">
            <form-list
            v-loading="loading6"
            :rules="rules" 
            refer="formEmail" 
            :model="formResource"
            :formList="editForm"
            @submit='editSumbit'
            >
            </form-list>
        </el-dialog>
  </div>
</template>

<script>
// import jsonp from 'jsonp'
// import qs from 'qs'
import FormList from '@/components/FormList'
import Pagination from '@/components/Pagination'
import { isNum, login } from "@/utils/index";
import {
  search
} from '@/api/common'
import {
  expertCheck,expertCheckNew
} from '@/api/center'
import {
  setClaim,
} from "@/api/detail";
export default {
  components: {
    Pagination,FormList
  },
  name: 'people',
  props: {
    Kid: {
      type: String,
      default: ''
    },
    isHttp: {
      type: String
    }
  },
  data () {
    return {
        user: localStorage.getItem("user"), // user
        formList:{
            n:'',
            o:''
        },
        fieldData:{
            total:0,
            data:[]
        },
        loading:false,
        pagetion: {
            from: 0,
            size: 11
        }, // 分页情况
        pageData:{
            
            layout: 'sizes, prev, pager, next, jumper', // 分页
            pageSizes: [11], // 每页条数
        },
        vldMobile: false, // 是否显示手机号输入框
        codeTxt:'获取验证码',
        code:'',
        msg:'',
        loading6:false,
        dialogVisible:false,
        nameOrgArray:{},//选中的对象
        showEdit:false,
        formResource:{},//表单数据
        success:false,//是否认领成功
        editForm:[//表单列表
            {label:'姓名：',tag:'name',value:'',type:'input',prop:'name',index:0,placeholder:'请输入姓名'},
            {label:'机构：',tag:'org',value:'',type:'input',prop:'org',index:1,placeholder:'请输入机构'},
            {label:'二级机构：',tag:'department',value:'',type:'input',prop:'department',index:2,placeholder:'请输入二级机构'},
            {label:'学科：',tag:'subject',value:'',type:'input',prop:'department',index:2,placeholder:'请输入学科'},
            {label:'研究方向：',tag:'keyword',value:'',type:'input',prop:'department',index:2,placeholder:'请输入研究方向'},
            {label:'提交',value:'',type:'button',index:3,loading:false,},
        ],
        rules: {
            name: [
                {required: true,  min:2, message: '至少两个字符',   trigger: 'blur' }
            ],
            org: [
                {required: true,  min:2, message: '至少两个字符', trigger: 'blur' }
            ],
            department: [
                { min:2, message: '至少两个字符', trigger: 'blur' }
            ],
        },
    }
  },
  methods: {
      // 获取新的专家列表数据
    goDetail(item){
     
      if (isNum(item.kId)) {
        this.$message('该专家已经认领过！')
        return;
      }
      if (this.user) {
        this.nameOrgArray = item;
        this.dialogVisible = true;
        this.msg = "确定要认领吗";
      } else {
        this.msg = "认领失败，请先登录";
        this.$alert("请先登录", "认领失败", {
          confirmButtonText: "确定",
          callback: (action) => {
            login();
          },
        });
      }
    },
    showEditDilog(clear){
       if(this.success){
            this.dialogVisible = false
            this.success = false;
            return
       }
       if(clear){
         this.nameOrgArray = {};
       }
       this.dialogVisible = false
       var obj = {}
        this.editForm.map(item => {
            if(item.type == 'input'){
                obj[item.tag] = this.nameOrgArray[item.tag] || ''
                if(item.tag == 'org'){
                    obj[item.tag] = this.nameOrgArray.organization
                }
            }
        })
        // this.nameOrgArray = {};//用完就清空
        this.formResource = obj;
        this.showEdit = true;
    },
    editSumbit(){
        console.log('提交',this.formResource)
        this.setClaim()
    },
    // 认领
    setClaim() {
      let user = JSON.parse(this.user);
      let data = {};
      let permission = [];
      data = {
        mobile: user.Mobile,
        kId:this.nameOrgArray.kId || null,
        ...this.formResource
      };
      // }
      // this.editForm[6].loading = true;
      this.loading6 = true;
      expertCheckNew(data)
        .then((res) => {
          if (res.data.status === 1) {//正确
            this.loading6 = false;  
            let datas = res.data.data;
            this.showEdit = false;
            this.msg = "专家认领成功，请在“专家管理”中进行后续专家信息及成果管理。";
            this.dialogVisible = true;
            this.success = true;
          }else{
              this.loading6 = false;  
              if(res.data.msg){
                this.$message({
                    message:res.data.msg,
                    type:res.data.status == 1?'success':'error',
                })
              }else{
                 this.$message({
                    message:'认领失败！',
                    type:'error',
                })
              }
             
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading6 = false;  
        });
        setTimeout(() => {
             this.loading6 = false;  
        }, 3000);
    },
    setAvatar(item){
      return new Promise((resolve) => {
        if(!isNaN(item.kId)){
          getBase64Avatar({kId:item.kId}).then(res => {
            resolve((res.data[0].data[0]&&res.data[0].data[0].avatar)?res.data[0].data[0].avatar.replace(/[\r\n]/g, ""):'')
          })
        }
      })
    },
    searching(params){
      search(params)
        .then(res => {
          if(res.status == 1){
            res.data.obj.map((item, index) => {
                var avatar = ''
                item.keywordList = item.keyword.split(';')
                // await this.setAvatar(item,index).then(res=>{
                //   item.avatar = res
                // })
                res.data.obj[index].avatar = avatar
            })
            res.data.data = res.data.obj;
            this.fieldData = res.data;
            this.loading = false;
          }
         
        })
        .catch(err => {
          console.log(err)
           this.loading = false;
        })
    },
    getPage ({...data}) {
      this.pagetion.from = data.page || 1;
      this.pagetion.size = data.limit || this.pagetion.size;
      this.getTabel2();
      
    },
    rest(){
        this.formList.n = '';
        this.formList.o = ''
        this.pagetion.from = 1;
        // this.formList.k
        this.fieldData = {
            total:0,
            data:[]
        }
    },
    getTabel2(){
      if(!this.formList.n){
          this.$message('请先填写姓名再进行搜索!')
          return
      }
      this.loading = true;  
      var params = {
          mix:1,
          kt:0,
          ...this.pagetion
      }
      if(this.formList.n){
        params.n =this.formList.n
      }
      if(this.formList.o){
         params.o =this.formList.o
      }
      params.from = params.from -= 1;
      this.searching(params)
    },
  },
  computed:{
     
  },
  watch: {
  
    isHttp: {
      handler (val) {
        
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">
    .people{
        padding: 20px 0;
        .el-button{
                padding: 12px 20px;
        }
    }
     .res-list {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          padding: 20px;
          .exp-box {
            margin-bottom: 15px;
            border: none;
            margin-right: 0;
            padding: 0;
            &-box{
              height: 100%;
              border: 1px #ccc solid;
              padding: 10px;
              margin-right:20px;
              height: 230px;
            }
            .create-btn{
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
            .exp-int {
              cursor: pointer;
              display: flex;
              flex-direction: row;
              .exp-header {
                float: left;
                /deep/ img {
                  display: block;
                  height: 100px;
                  width: 80px;
                }
              }
              .exp-textint {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 10px;
                font-size: 12px;
                h5 {
                  margin-bottom: 10px;
                  cursor: pointer;
                }
                p {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-bottom: 5px;
                }
              }
            }
            .isni {
              font-size: 12px;
              margin-top: 10px;
              min-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .subject {
              min-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
            }
            .keywords {
              height: 44px;
              overflow: hidden;
              background-color: #f5f5f5;
              margin-top: 5px;
              li {
                height: 20px;
                float: left;
                border: 1px #ccc solid;
                padding: 1px 2px;
                border-radius: 4px;
                font-size: 12px;
                margin: 0 4px 2px 0;
              }
            }
          }
          //  div.exp-box:nth-child(4n){
          //   .exp-box-box{
          //      margin-right:0px
          //   }
          // }
          // div.exp-box:nth-child(4n+2){
          //   .exp-box-box{
          //      margin: 0 10px;
          //   }
          // }
          // div.exp-box:nth-child(4n+3){
          //   .exp-box-box{
          //      margin:0 10px;
          //   }
          // }
        }
        .res-listelse {
          ul {
            li {
              ::-webkit-scrollbar {
                width: 6px;
                background-color: #f2f2f2;
              }
              ::-webkit-scrollbar-thumb {
                background-color: #dedede;
              }
              height: 240px;
              border: 1px #ccc solid;
              padding: 20px;
              margin-bottom: 10px;
              .eles-info {
                display: flex;
                flex-direction: row;
                .else-header {
                  cursor: pointer;
                  float: left;
                  img {
                    display: block;
                    width: 120px;
                    height: 160px;
                    margin-right: 15px;
                  }
                }
                .else-int {
                  float: left;
                  margin-right: 15px;
                  h5 {
                    font-size: 14px;
                  }
                  p {
                    width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                    margin-top: 10px;
                  }
                  .else-keywords {
                    width: 300px;
                    height: 48px;
                    overflow: hidden;
                    margin-top: 10px;
                    span,
                    a {
                      font-size: 12px;
                    }
                    a {
                      height: 20px;
                      margin: 0 5px 4px 0;
                      display: inline-block;
                      border: 1px #ccc solid;
                      padding: 2px 4px;
                      border-radius: 4px;
                    }
                  }
                }
              }
              .else-chart {
                margin-top: 30px;
              }
              .elseinttext {
                float: left;
                width: 60%;
                font-size: 12px;
                overflow: auto;
                height: 200px;
                text-indent: 2em;
                .elseinttext-item {
                  border: none;
                  margin-bottom: 0;
                  height: 200px;
                }
              }
            }
          }
        }
</style>



// WEBPACK FOOTER //
// src/view/center/menu/people.vue